import CustomGrid from "../../../common/CustomGrid"
import { useFetchGet } from "../../../common/fetchGetApi"
import { FinaltoRoutesName, decimalPlace } from "../utils"


let ColumnData = [
    { field: 'symbol', headerText: 'Instrument', width: '' },
    { field: 'netQty', headerText: 'Qty', width: '', format: decimalPlace() },
    { field: 'openPrice', headerText: 'Open Price', width: '', format: decimalPlace(5) },
    { field: 'currentPrice', headerText: 'Current Price', width: '', format: '' },
    { field: 'openPL', headerText: 'PnL', width: '' },
]

function Positions() {
    const { isLoading, apiData = [], serverError } = useFetchGet(FinaltoRoutesName.positions)

    return (
        <>
            <CustomGrid ColumnData={ColumnData} apiData={apiData} isLoading={isLoading} />
        </>
    )
}

export default Positions